import { BaseModule } from '@core/base/module/base-module'
import { AssetsService } from '@core/services/api-gateway'

const state = {
    loading: false,
    error: false,
    lastFetched: '',
    securityScore: null,
} satisfies ISecurityAssessmentsState

class SecurityAssessments extends BaseModule<ISecurityAssessmentsState> {
    constructor(state: ISecurityAssessmentsState) {
        super(state, 'security-assessments.module')
    }

    getData(): number | null | undefined {
        const { securityScore } = this.useStore()
        return securityScore
    }

    async loadSecurityAssessments(forced?: boolean) {
        const store = this.store

        if (!store.get().lastFetched || forced) {
            store.setKey('loading', true)

            const result = await AssetsService.getSecurityAssessment()

            if (!result) {
                store.setKey('loading', false)
                store.setKey('error', true)
                return false
            }
            store.setKey('securityScore', result.securityScore)
            store.setKey('lastFetched', Date.now())
            store.setKey('loading', false)
            return result.securityScore
        }
        return store.get().securityScore
    }
}

export const SecurityAssessmentsModule = new SecurityAssessments(state)
